import { MediaStage } from "@/core/types/mediaTypes";

export interface MediaStageStyle {
  label: string;
  color: string;
}

export const MEDIA_STAGE_CONFIG: Record<MediaStage, MediaStageStyle> = {
  [MediaStage.DRAFT]: { label: "Bozza", color: "bg-yellow-500" },
  [MediaStage.PENDING_APPROVAL]: { label: "In attesa", color: "bg-orange-500" },
  [MediaStage.APPROVED]: { label: "Approvato", color: "bg-green-500" },
  [MediaStage.LEGACY_USED]: { label: "Usato", color: "bg-purple-500" },
  [MediaStage.ARCHIVED]: { label: "Archiviato", color: "bg-blue-500" },
  [MediaStage.DISCARDED]: { label: "Scartato", color: "bg-gray-500" },
};

export const MEDIA_STAGE_ORDER: MediaStage[] = [
  MediaStage.DRAFT,
  MediaStage.PENDING_APPROVAL,
  MediaStage.APPROVED,
  MediaStage.LEGACY_USED,
  MediaStage.ARCHIVED,
  MediaStage.DISCARDED,
];
